
import { Outlet } from 'react-router-dom';
import { Header } from './Header';
import { AppSidebar } from './AppSidebar';
import { SidebarProvider, SidebarTrigger } from './ui/sidebar';

const LayoutContent = () => {

  return (
    <div className="min-h-screen bg-brand-background flex w-full">
      <Header className="fixed top-0 left-0 right-0 z-50 mx-0 px-2 sm:px-[11px]">
        <div className="flex items-center gap-2">
          <SidebarTrigger />
        </div>
      </Header>
      <div className="flex w-full">
        <AppSidebar />
        <main className="flex-1 h-screen pt-16 px-2 sm:px-4 md:px-0 overflow-y-auto min-w-0 transition-all duration-300 ease-out will-change-transform">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

const Layout = () => {
  return (
    <SidebarProvider defaultOpen={false}>
      <LayoutContent />
    </SidebarProvider>
  );
};
export default Layout;
